import { useMemo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import { useTranslation } from 'modules/i18n';

import { GetTasksResult } from '../../actions/getTasks';
import { getGroupedTasksData } from '../../utils';
import { Empty } from '../Empty/Empty';
import translation from './groupedTasksTable.translation';
import { Row } from './Row';

interface Props {
  tasks: GetTasksResult;
}

export function GroupedTasksTable({ tasks }: Props): JSX.Element {
  const { t, keys } = useTranslation(translation);

  const groupedTasksData = useMemo(() => getGroupedTasksData(tasks), [tasks]);

  return (
    <div>
      <Table>
        <TableHead
          sx={theme => ({
            [theme.breakpoints.down('md')]: {
              display: 'none',
            },
          })}
        >
          <TableRow>
            <TableCell width="50%">{t(keys.name)}</TableCell>

            <TableCell align="left" width="20%">
              {t(keys.tasks)}
            </TableCell>

            <TableCell align="right" width="30%">
              {t(keys.amountSpent)}
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {groupedTasksData.map(({ address, chainId, tasks }) => (
            <Row
              key={`${chainId}_${address}`}
              address={address}
              chainId={chainId}
              tasks={tasks}
            />
          ))}
        </TableBody>
      </Table>

      {!groupedTasksData.length && <Empty />}
    </div>
  );
}
